module.exports = __webpack_public_path__ + "media/splash/launch-828x1792-eb141a7c.png";